"use client";

import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_ADDITIONAL_WARM_GRAY_3U, COLOR_BLACK } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { FILTER_CLASSES } from "./constants";

interface StyleProps {
  isScrollbar?: boolean;
  isColorFilter?: boolean;
  isShopFilter?: boolean;
}
export const FilterContainer = styled(
  ({
    isScrollbar,
    isColorFilter,
    isShopFilter,
    ...restProps
  }: StyleProps & BoxProps) => <Box {...restProps} />,
)(({ isScrollbar, isShopFilter, theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    position: "relative",
    background: isShopFilter ? COLOR_ADDITIONAL_WARM_GRAY_3U : "unset",
    [`& .${FILTER_CLASSES.filterLabel}`]: {
      padding: theme.spacing(0, 1.5, 0, 4),
      [formatMedia.BREAKPOINT_DESKTOP]: {
        padding: theme.spacing(0, 1.25, 0, 2),
      },
    },
    [`& .${FILTER_CLASSES.accordionTitleContent}`]: {
      display: "block",
      margin: "17px 0",
    },
    [`& .${FILTER_CLASSES.labelContainer}`]: {
      display: "flex",
      flexWrap: "wrap",
    },
    [`& .${FILTER_CLASSES.label}`]: {
      color: COLOR_BLACK,
      textTransform: "capitalize",
      lineHeight: "24px !important",
      marginRight: theme.spacing(1),
    },
    [`& .${FILTER_CLASSES.filterItemsContainer}`]: {
      display: "flex",
      paddingBottom: theme.spacing(1),
      overflow: isScrollbar ? "auto" : "hidden",
      alignItems: "stretch",
      width: "100%",
      [formatMedia.BREAKPOINT_DESKTOP]: {
        maxHeight: 320,
      },
    },
    [`& .${FILTER_CLASSES.colorTag}`]: {
      width: 32,
      height: 32,
      marginRight: theme.spacing(1.5),
    },
    [`& .${FILTER_CLASSES.hideOnDesktop}`]: {
      [formatMedia.BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
  };
});
